import avatar from '../assets/images/avatar.webp';
import avatarTwo from '../assets/images/avatar-ath-academy.webp';

const graduatePhotos = {
    chizaram: '/graduates/nwachi-chizaram-samuel.webp',
    onyedikachi: '/graduates/onyedikachi-obinnaya-enyinnaya.webp',
    chukwuebuka: '/graduates/onwuka-chukwuebuka-prosper.webp',
    obinna: '/graduates/obinna-daniels-maraizu.webp',
    chidinma: '/graduates/esomonu-chidinma-stella.webp',
    nmesoma: '/graduates/okoli-nmesoma-paullete.webp',
    iheanyi: '/graduates/ogbonnaya-iheanyi-chinasa.webp',
    godson: '/graduates/onuigbo-godson-chibikem.webp',
};

export const talents = [
    {
        id: 1,
        slug: 'nwachi-chizaram-samuel',
        name: 'Nwachi Chizaram Samuel',
        title: 'Cyber Security Specialist',
        skills: ['Network Security', 'Ethical Hacking', 'Risk Assessment', 'Compliance'],
        experience: 'Recent Graduate',
        location: 'Abia, Nigeria',
        availability: 'Available',
        phone: '07040752498',
        email: 'nwachichizarm@gmail.com',
        image: graduatePhotos.chizaram,
        fallbackImage: avatar,
        verified: true,
        description: 'Cybersecurity expert with hands-on experience in network security and ethical hacking. Graduate of Cybersecurity program at Abia Tech Hub Academy.',
    },
    {
        id: 2,
        slug: 'onyedikachi-obinnaya-enyinnaya',
        name: 'Onyedikachi Obinnaya Enyinnaya',
        title: 'Fullstack Web Developer',
        skills: ['React', 'Node.js', 'MongoDB', 'JavaScript', 'HTML', 'CSS'],
        experience: 'Recent Graduate',
        location: 'Abia, Nigeria',
        availability: 'Available',
        phone: '09042378697',
        email: 'onyedikachiobinnaya5@gmail.com',
        image: graduatePhotos.onyedikachi,
        fallbackImage: avatar,
        verified: true,
        description: 'Passionate full-stack developer with expertise in modern web technologies. Completed Fullstack Web Development course at Abia Tech Hub Academy.',
    },
    {
        id: 3,
        slug: 'onwuka-chukwuebuka-prosper',
        name: 'Onwuka Chukwuebuka Prosper',
        title: 'Fullstack Web Developer',
        skills: ['React', 'Node.js', 'MongoDB', 'JavaScript', 'Express', 'Git'],
        experience: 'Recent Graduate',
        location: 'Abia, Nigeria',
        availability: 'Available',
        phone: '08107508782',
        email: 'Onwukaprosper2000@gmail.com',
        image: graduatePhotos.chukwuebuka,
        fallbackImage: avatar,
        verified: true,
        description: 'Skilled full-stack developer with strong foundation in web development technologies. Graduate of Fullstack Web Development program at Abia Tech Hub Academy.',
    },
    {
        id: 4,
        slug: 'obinna-daniels-maraizu',
        name: 'Obinna Daniels Maraizu',
        title: 'Fullstack Web Developer',
        skills: ['React', 'Node.js', 'MongoDB', 'JavaScript', 'API Development', 'Database Design'],
        experience: 'Recent Graduate',
        location: 'Abia, Nigeria',
        availability: 'Available',
        phone: '07068617629',
        email: 'maraizuod@gmail.com',
        image: graduatePhotos.obinna,
        fallbackImage: avatar,
        verified: true,
        description: 'Full-stack developer with expertise in building scalable web applications. Completed Fullstack Web Development course at Abia Tech Hub Academy.',
    },
    {
        id: 5,
        slug: 'esomonu-chidinma-stella',
        name: 'Esomonu Chidinma Stella',
        title: 'Cyber Security Specialist',
        skills: ['Network Security', 'Ethical Hacking', 'Vulnerability Assessment', 'Security Protocols'],
        experience: 'Recent Graduate',
        location: 'Abia, Nigeria',
        availability: 'Available',
        phone: '07033842979',
        email: 'stellachidimna@gmail.com',
        image: graduatePhotos.chidinma,
        fallbackImage: avatarTwo,
        verified: true,
        description: 'Cybersecurity professional with knowledge in network security and ethical hacking practices. Graduate of Cybersecurity program at Abia Tech Hub Academy.',
    },
    {
        id: 6,
        slug: 'okoli-nmesoma-paullete',
        name: 'Okoli Nmesoma Paullete',
        title: 'Fullstack Web Developer',
        skills: ['React', 'Node.js', 'MongoDB', 'JavaScript', 'Frontend Development', 'Backend Development'],
        experience: 'Recent Graduate',
        location: 'Abia, Nigeria',
        availability: 'Available',
        phone: '08069679237',
        email: 'okolipaullette32@gmail.com',
        image: graduatePhotos.nmesoma,
        fallbackImage: avatarTwo,
        verified: true,
        description: 'Full-stack developer with comprehensive knowledge of modern web development stack. Completed Fullstack Web Development course at Abia Tech Hub Academy.',
    },
    {
        id: 7,
        slug: 'ogbonnaya-iheanyi-chinasa',
        name: 'Ogbonnaya Iheanyi Chinasa',
        title: 'Fullstack Web Developer',
        skills: ['React', 'Node.js', 'MongoDB', 'JavaScript', 'Web Development', 'Database Management'],
        experience: 'Recent Graduate',
        location: 'Abia, Nigeria',
        availability: 'Available',
        phone: '07033842977',
        email: 'Stanleyiheanyi260@gmail.com',
        image: graduatePhotos.iheanyi,
        fallbackImage: avatar,
        verified: true,
        description: 'Skilled full-stack developer with expertise in building dynamic web applications. Graduate of Fullstack Web Development program at Abia Tech Hub Academy.',
    },
    {
        id: 8,
        slug: 'onuigbo-godson-chibikem',
        name: 'Onuigbo Godson Chibikem',
        title: 'Cyber Security Specialist',
        skills: ['Network Security', 'Ethical Hacking', 'Penetration Testing', 'Security Analysis'],
        experience: 'Recent Graduate',
        location: 'Abia, Nigeria',
        availability: 'Available',
        phone: '09077693773',
        email: 'godsononigbo@gmail.com',
        image: graduatePhotos.godson,
        fallbackImage: avatar,
        verified: true,
        description: 'Cybersecurity expert with hands-on experience in network security and ethical hacking. Graduate of Cybersecurity program at Abia Tech Hub Academy.',
    },
];

export const getTalents = () => talents;

export const getFeaturedTalents = (count = 3) => talents.slice(0, count);

export const getStaticTalentBySlug = (slug) =>
    talents.find((t) => t.slug === slug) || null;
